import firebase from 'firebase/compat/app';
import { appConfig } from '@tyrio/config';
import { getAuth } from 'firebase/auth';

const firebaseApp = firebase.initializeApp(appConfig.firebase);
const fbAuth = getAuth(firebaseApp);

export { firebaseApp, fbAuth };
